export default {
  back: false,
  loader: false
}



// WEBPACK FOOTER //
// ./src/store/navigation/state.js